import { IntersectionObserverOptions } from "hooks/useIntersectionObserver";
import useOnScreen from "hooks/useOnScreen";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import Form from "./Form";
import {
  Container,
  FormContainer,
  ImageContainer,
  StyledContentContainer,
  StyledNewsletterImage,
} from "./styles";

const intersectionOptions: IntersectionObserverOptions = {
  unobserveOnIntersection: true,
};

const Newsletter: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(containerRef, intersectionOptions);
  const { t } = useTranslation();

  return (
    <aside>
      <StyledContentContainer>
        <Container ref={containerRef} isOnScreen={isOnScreen}>
          <ImageContainer>
            <StyledNewsletterImage
              role="img"
              aria-labelledby={t("10693") /* Cidade inteligente */}
              title={t("10693") /* Cidade inteligente */}
            />
          </ImageContainer>
          <FormContainer>
            <Form />
          </FormContainer>
        </Container>
      </StyledContentContainer>
    </aside>
  );
};

export default Newsletter;
